import Quote from "@system/config/quote";
import Api from "./APIHandler";
import quoteDetailAPICallResponseMaker from "./reponseMaker/quoteDetailAPICallResponseMaker";
import Helper from "src/helper/Helper";
import { __remove, __set } from "../store/axios_indicator";

const API = new Api({});
class QuoteAPICall {

    addQuote = async (params) => {
        let res = {};
        let reqData = {}
        reqData.data = params
        __set("ADD_TO_QUOTE_API_CALL")
        await API.post(Quote.ADD_QUOTE, reqData).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        }).finally(() => {
            __remove("ADD_TO_QUOTE_API_CALL")
        });
        return res;
    };

    addQuoteInBulk = async (params) => {
        let res = {};
        let reqData = {}
        reqData.data = params
        await API.post(Quote.ADD_QUOTE_IN_BULK, reqData).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res;
    };

    sendSubmittedQuoteEmail = async (params) => {
        let res = {};
        let reqData = {}
        reqData.data = params
        await API.post(Quote.SUBMITTED_QUOTE_EMAIL, reqData).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data.data
            }
        });
        return res;
    };

    clearAllQuote = async () => {
        let res = {};
        await API.delete(Quote.CLEAR_ALL_QUOTE, {}).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };

    clearSingleQuote = async (quoteId) => {
        let res = {};
        let reqData = {}
        reqData.params = {
            lineItemId: quoteId
        }
        __set("DELETE_QUOTE_API_CALL")
        await API.delete(Quote.CLEAR_SINGLE_QUOTE, reqData).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        }).finally(() => {
            __remove("DELETE_QUOTE_API_CALL")
        });
        return res;
    };

    editQuote = async (params) => {
        let Obj = { items: [] };
        Obj.items.push(params[0].params);
        let res = {};
        let reqData = {}
        reqData.data = Obj
        __set("EDIT_QUOTE_API_CALcL")
        await API.put(Quote.EDIT_QUOTE, reqData).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        }).finally(() => {
            __remove("EDIT_QUOTE_API_CALL")
        });
        return res;
    };

    submitQuote = async (params = {}) => {
        let res = {};
        let reqData = {}
        reqData.data = params
        await API.post(Quote.SUBMIT_QUOTE, reqData).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res;
    };

    addUpdateProjectData = async (params = {}) => {
        let res = {};
        let reqData = {}
        reqData.data = params
        await API.post(Quote.ADD_UPDATE_PROJECT_DATA, reqData).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res;
    };

    getSubmittedQuoteList = async (params = {}) => {
        let res = { count: 0, records: [] };
        let reqData = {}
        reqData.data = params
        await API.post(Quote.QUOTE_SUBMITTED_LIST, reqData).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                if (resHer.data.data) {
                    if (resHer.data.data?.quoteHeaderRecords.length > 0) {
                        resHer.data.data?.quoteHeaderRecords.forEach(element => {
                            element['isLoad'] = false
                        });
                    }
                    res = {
                        count: resHer.data.data?.totalRecords,
                        records: resHer.data.data?.quoteHeaderRecords
                    };
                }
            }
        });
        return res;
    };

    searchQuote = async (params = {}) => {
        let res = {};
        let reqData = {}
        reqData.data = params
        await API.post(Quote.QUOTE_SUBMITTED_DETAIL_LIST_WITH_STATUS, reqData).then((resHer) => {
            res = resHer.data.data;
        }).catch((err) => {
            res = false;
        });
        return res;
    };

    getOpenQuoteList = async (params = {}) => {
        let res = {};
        let reqData = {}
        reqData.data = params
        await API.post(Quote.OPEN_QUOTE_LIST, reqData).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });

        return res
    };

    getSubmittedQuoteExportUrl = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        param.data.responseType = 'blob';
        await API.post(Quote.EXPORT_QUOTE_LIST, param).then((resHer) => {
            res = resHer.data;
            let _fileName = params.quoteNumber ? params.quoteNumber : params.provisionalId;
            Helper.downloadFileFromRes(resHer.data, 'Quotes_' + _fileName + '.' + params.fileType)
        });
        __remove('EXPORT_URL')
        return res;
    };

    getLineItemsDetail = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        await API.post(Quote.QUOTE_SUBMITTED_DETAIL_LIST_BY_STATUS, param).then((resHer) => {
            try {
                res = resHer.data?.data;
            } catch (e) {
                failed = true;
            }
        });

        let result = await new quoteDetailAPICallResponseMaker(res);
        result = await result.process(params);
        return result.run().get()
    };

    get_Dowpdown_List = async () => {
        let res = {};
        await API.get(Quote.QUOTE_DROPDOWN_LIST, {}).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
                res.businessType.sort((a, b) => {
                    if (a.refQuoteName.toLowerCase() < b.refQuoteName.toLowerCase()) return -1;
                    if (a.refQuoteName.toLowerCase() > b.refQuoteName.toLowerCase()) return 1;
                    return 0;
                })
                res.industry.sort(function (a, b) {
                    if (a.refQuoteName.toLowerCase() < b.refQuoteName.toLowerCase()) return -1;
                    if (a.refQuoteName.toLowerCase() > b.refQuoteName.toLowerCase()) return 1;
                    return 0;
                })
                res.businessType.forEach(function (item, i) {
                    if (item.refQuoteName === "Other") {
                        res.businessType.splice(i, 1);
                        res.businessType.push(item);
                    }
                })
            }
        });
        return res
    };

    get_Project_Data = async () => {
        let res = {};
        await API.get(Quote.QUOTE_PROJECT_DATA, {}).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        });
        return res
    };

}

export default QuoteAPICall;